<template>
  <div class="gs-app gs-refresh-controls gv-video-settings-panel">
    <div v-if="storageSettingsTab === 'grooveStorage'">
      <div class="w-full flex videoEncoder">
        <div class="w-full flex flex-col flex-nowrap items-center justify-center">
          <div class="gv-storage__badge">
            <img
              src="../../assets/images/videos/Storage-Icon.png"
              alt="Storage-Icon"
            />
          </div>
          <h3 class="gv-storage__heading">
            {{
              $t(
                'frontend_groovevideo_members_settings_index_pro'
              )
            }}
          </h3>
          <p class="gv-storage__copy">
            {{
              $t('frontend_groovevideo_members_settings_index_as_you')
            }}
          </p>
          <div class="gv-storage__meter-block">
            <div
              class="gv-storage__meter"
              role="progressbar"
              aria-label="Storage used"
              aria-valuemin="0"
              :aria-valuenow="storageUsed > 0 ? storageUsed : 0"
              :aria-valuemax="totalStorage ?? 100"
            >
              <div
                class="gv-storage__meter-fill"
                :style="{
                  width:
                    Math.min(
                      100,
                      ((storageUsed > 0 ? storageUsed : 0) /
                        (totalStorage || 100)) *
                        100
                    ) + '%',
                }"
              ></div>
            </div>
            <p class="gv-storage__usage">
              {{
                $t('frontend_groovevideo_members_settings_index_you_have_used')
              }}
              <strong>
                <span class="gv-storage__usage-value">{{
                  storageUsed > 0 ? storageUsed : 0
                }}GB</span> / {{
                  totalStorage ?? 100
                }}GB</strong
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div
        v-if="storageAccounts.length >= 1"
        class="flex flex-row justify-end w-full gv-storage__toolbar"
      >
        <div class="text-right">
          <dropdown-button class="w-full">
            <span slot="link" class="gv-storage__add-trigger">
              <gs-icon name="plus" size="15" />
              <span>
                {{
                  $t(
                    'frontend_groovevideo_members_settings_index_add_new'
                  )
                }}
              </span>
              <gs-icon name="chevron-down" size="15" />
            </span>
            <div slot="dropdown" class="gv-storage__menu">
              <div
                v-for="(integration, index) in storageIntegrations"
                :key="index"
                class="gv-storage__menu-item"
                @click="addNewIntegration(integration.id)"
              >
                {{ integration.name }}
              </div>
            </div>
          </dropdown-button>
        </div>
      </div>
      <div class="w-full">
        <div v-if="storageAccounts.length > 0" class="gv-storage__grid">
          <gs-card
            v-for="(storage, storageIndex) in storageAccounts"
            :key="storageIndex"
            class="storage-section gv-storage__account"
          >
            <div class="gv-storage__account-logo">
              <img
                src="../../assets/images/videos/aws-logo.png"
                alt="content-img"
                class="responsive"
              />
            </div>
            <div class="gv-storage__account-footer">
              <div class="gv-storage__account-name">
                {{ storage.name }}
              </div>
              <gs-button
                variant="ghost"
                size="sm"
                class="is-destructive"
                :aria-label="$t('frontend_delete')"
                @click="deleteStorage(storage.id)"
              >
                <gs-icon name="trash" size="15" />
              </gs-button>
            </div>
          </gs-card>
        </div>
        <div v-else class="w-full">
          <div class="w-full flex videoEncoder">
            <div
              class="w-full flex flex-col flex-nowrap items-center justify-center"
            >
              <div class="gv-storage__badge">
                <img
                  src="../../assets/images/videos/Storage-Icon.png"
                  alt="Storage-Icon"
                />
              </div>
              <h3 class="gv-storage__heading">
                {{
                  $t(
                    'frontend_groovevideo_members_settings_index_lets_setup'
                  )
                }}
              </h3>
              <p class="gv-storage__copy">
                <span v-if="!$store.getters.canUseStorage">
                  <strong class="gv-storage__copy-strong">
                    {{
                      $t(
                        'frontend_groovevideo_members_settings_index_free'
                      )
                    }} </strong
                  ><br />
                  {{
                    $t(
                      'frontend_groovevideo_members_settings_index_free_members'
                    )
                  }}
                </span>
                <span v-else>
                  {{
                    $t('frontend_groovevideo_members_settings_index_pro_members')
                  }}
                </span>
              </p>
              <div
                v-if="this.$store.getters.canUseStorage"
                class="gv-storage__actions"
              >
                <gs-button
                  variant="primary"
                  size="lg"
                  @click="addNewIntegration(0)"
                >
                  {{
                    $t(
                      'frontend_groovevideo_members_settings_index_connect_aws'
                    )
                  }}
                </gs-button>
              </div>
              <div v-else class="gv-storage__actions gv-storage__actions--stacked">
                <gs-button
                  v-if="this.$store.getters.canUseStorage"
                  variant="primary"
                  size="lg"
                >
                  {{
                    $t(
                      'frontend_groovevideo_members_settings_index_upgrade_to'
                    )
                  }}
                </gs-button>
                <gs-button v-else variant="primary" size="lg">
                  {{
                    $t(
                      'frontend_groovevideo_members_settings_index_pro_users_get'
                    )
                  }}
                </gs-button>
                <gs-button
                  variant="outline"
                  size="lg"
                  class="thanksBtn"
                  @click="addNewIntegration(0)"
                >
                  {{
                    $t(
                      'frontend_groovevideo_members_settings_index_nothanks'
                    )
                  }}
                </gs-button>
              </div>
              <p class="gv-storage__help">
                {{
                  $t(
                    'frontend_groovevideo_members_settings_index_need_help'
                  )
                }}
                <a href="#" class="gv-storage__help-link">
                  {{
                    $t(
                      'frontend_groovevideo_members_settings_visit_help_center'
                    )
                  }}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <gs-named-modal name="add-s3-account-modal" :title="$t('frontend_groovevideo_add_details')" @closed="resetModal">
        <div class="gs-app gs-refresh-controls flex flex-col m-6 gv-video-settings-modal-body">
          <gs-field :label="$t('frontend_groovevideo_members_settings_index_name')">
            <text-input
              v-model="model.integration_name"
              :validator="$v.model.integration_name"
              value="model.integration_name"
              :attribute="$t('frontend_name')"
              :placeholder="
                $t(
                  'frontend_groovevideo_members_settings_enter_integration_name'
                )
              "
            />
          </gs-field>
          <gs-field :label="$t('frontend_groovevideo_members_settings_key')">
            <text-input
              v-model="model.key"
              :validator="$v.model.key"
              value="model.key"
              :attribute="$t('frontend_groovevideo_videos_integration_key')"
              :placeholder="
                $t('frontend_groovevideo_members_settings_enter_key')
              "
            />
          </gs-field>
          <gs-field :label="$t('frontend_groovevideo_members_settings_secret')">
            <text-input
              v-model="model.secret"
              :validator="$v.model.secret"
              value="model.secret"
              :attribute="$t('frontend_groovevideo_videos_integration_secret')"
              :placeholder="
                $t('frontend_groovevideo_members_settings_enter_secret')
              "
            />
          </gs-field>
          <gs-field :label="$t('frontend_groovevideo_members_settings_region')">
            <text-input
              v-model="model.region"
              :validator="$v.model.region"
              value="model.region"
              :attribute="$t('frontend_groovevideo_videos_integration_region')"
              :placeholder="
                $t('frontend_groovevideo_members_settings_enter_region')
              "
            />
          </gs-field>
          <div class="flex flex-row w-full justify-end gv-video-settings-modal-actions">
            <gs-button
              class="text-center w-40"
              size="lg"
              variant="primary"
              @click="saveStorageDetails()"
            >
              {{ $t('frontend_groovevideo_members_settings_create') }}
            </gs-button>
          </div>
        </div>
      </gs-named-modal>
    </div>
  </div>
</template>
<script>
import Swal from 'sweetalert2';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import Storage from '@/models/Storage';

export default {
  props: {
    storageAccounts: {
      required: true,
    },
    totalStorage: {
      default: 100,
    },
    storageUsed: {
      default: 0,
    },
    storageSettingsTab: {
      default: 'ownStorage',
    }
  },
  components: {},
  data () {
    return {
      model: {
        name: '',
        key: '',
        secret: '',
        region: '',
        integration_name: '',
      },
    };
  },
  validations: {
    model: {
      name: {
        required,
        minLength: minLength(3), 
        maxLength: maxLength(20),
      },
      key: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(40),
      },
      secret: {
        required,
        minLength: minLength(3),
      },
      region: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100),
      },
      integration_name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100),
      },
    },
  },
  computed: {
    storageIntegrations() {
      return [{ name: this.$t('frontend_groovevideo_add_new_s3_integration') }];
    },
  },
  methods: {
    addNewIntegration() {
      this.$root.$emit('modal-open', 'add-s3-account-modal');
    },
    resetModal () {
      this.model = {
        name: '',
        key: '',
        secret: '',
        region: '',
        integration_name: '',
      };
      this.$v.$reset();
    },
    async saveStorageDetails() {
      this.$v.model.key.$touch();
      this.$v.model.secret.$touch();
      this.$v.model.region.$touch();
      this.$v.model.integration_name.$touch();

      if (
        !this.$v.model.key.$invalid &&
        !this.$v.model.secret.$invalid &&
        !this.$v.model.region.$invalid &&
        !this.$v.model.integration_name.$invalid
      ) {
        this.$emit('setIsLoading', true);
        this.store = new Storage({});
        this.store.key = this.model.key;
        this.store.secret_key = this.model.secret;
        this.store.region = this.model.region;
        this.store.integration_name = this.model.integration_name;

        const self = this;

        this.store
          .save()
          .then((response) => {
            if (!response.status && response.message) {
              Swal.fire(this.$t('frontend_error'), response.message, 'error');
            } else {
              self.store = response.data;
              self.storageAccounts.push(self.store);
            }
            self.$root.$emit('modal-close', 'add-s3-account-modal');
            self.resetModal();
            self.$emit('setIsLoading', false);
          })
          .catch(() => {
            this.$emit('setIsLoading', false);
          });
      }
    },
    async deleteStorage (id) {
      const { value: accept } = await Swal.fire({
        title: this.$t('frontend_sure'),
        text: this.$t('frontend_non_revertable'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('frontend_delete_confirm'),
      });

      if (accept) {
        this.$emit('setIsLoading', true);
        try {
          const storage = await Storage.$find(id);
          const response = await storage.delete();

          if (response && response.data && response.data.status) {
            const storageIndex = this.storageAccounts.findIndex(
              (el) => el.id === id
            );
          
            this.storageAccounts.splice(storageIndex, 1);
          } else {
            Swal.fire(this.$t('frontend_groovevideo_warning_title'), this.$t('frontend_groovevideo_storage_already_in_use'), 'warning');
          }
        } catch (err) {
          Swal.fire(
            this.$t('frontend_error'),
            this.$t('frontend_backend_error'),
            'error'
          );
        }
        this.$emit('setIsLoading', false);
      }
    }
  },
};
</script>
<style>
.videoEncoder h3 {
  font-size: 20px !important;
  color: #191d3a;
}
.btngroup button {
  width: calc(100% - 22rem);
  min-width: 375px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.storage-section {
  width: 23.5% !important;
  height: 267px !important;
  min-width: 250px !important;
}
.storage-section .rounded-md-top {
  border-radius: 4px 4px 0px 0px !important;
}
.thanksBtn {
  color: #191d3a !important;
}
</style>

<style>
.gv-video-settings-panel .videoEncoder { padding: 24px; border: 1px solid var(--gs-border); border-radius: var(--gs-radius-lg); background: var(--gs-surface-subtle); }
.gv-video-settings-panel .storage-section { border: 1px solid var(--gs-border); border-radius: var(--gs-radius-lg); box-shadow: var(--gs-shadow-sm); }
.gv-video-settings-modal-body { gap: 12px; max-width: 720px; }
@media (max-width: 640px) { .gv-video-settings-panel .videoEncoder { padding: 16px; } .gv-video-settings-panel .videoEncoder .w-2\/5, .gv-video-settings-panel .videoEncoder .w-3\/5 { width: 100% !important; } .gv-video-settings-modal-body { margin: 16px !important; } }
</style>

<style>
.gv-video-settings-panel .gv-storage__badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: var(--gs-muted);
}

.gv-video-settings-panel .gv-storage__heading {
  margin: 20px 0 8px;
  color: var(--gs-foreground);
  font-size: 18px;
  font-weight: 700;
  text-align: center;
}

.gv-video-settings-panel .gv-storage__copy {
  margin: 0 0 20px;
  max-width: 34rem;
  color: var(--gs-muted-foreground);
  font-size: 14px;
  text-align: center;
}

.gv-video-settings-panel .gv-storage__copy-strong {
  color: var(--gs-foreground);
}

.gv-video-settings-panel .gv-storage__meter-block {
  width: 100%;
  max-width: 34rem;
}

.gv-video-settings-panel .gv-storage__meter {
  overflow: hidden;
  height: 8px;
  border-radius: var(--gs-radius-sm);
  background: var(--gs-muted);
}

.gv-video-settings-panel .gv-storage__meter-fill {
  height: 100%;
  min-width: 2px;
  border-radius: var(--gs-radius-sm);
  background: var(--gs-primary);
}

.gv-video-settings-panel .gv-storage__usage {
  margin: 10px 0 0;
  color: var(--gs-muted-foreground);
  font-size: 14px;
  text-align: center;
}

.gv-video-settings-panel .gv-storage__usage-value {
  color: var(--gs-primary);
}

.gv-video-settings-panel .gv-storage__toolbar {
  margin-bottom: 16px;
}

.gv-video-settings-panel .gv-storage__add-trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  border-radius: var(--gs-radius-md);
  background: var(--gs-primary);
  color: var(--gs-primary-foreground);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.gv-video-settings-panel .gv-storage__menu {
  overflow: hidden;
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
  background: var(--gs-surface);
  box-shadow: var(--gs-shadow-md);
}

.gv-video-settings-panel .gv-storage__menu-item {
  padding: 10px 14px;
  color: var(--gs-foreground);
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;
}

.gv-video-settings-panel .gv-storage__menu-item:hover {
  background: var(--gs-muted);
}

.gv-video-settings-panel .gv-storage__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
  width: 100%;
}

.gv-video-settings-panel .gv-storage__account.storage-section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: auto !important;
  height: auto !important;
  min-width: 0 !important;
  padding: 20px;
}

.gv-video-settings-panel .gv-storage__account-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 88px;
}

.gv-video-settings-panel .gv-storage__account-logo img {
  max-height: 100%;
}

.gv-video-settings-panel .gv-storage__account-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid var(--gs-border);
}

.gv-video-settings-panel .gv-storage__account-name {
  overflow: hidden;
  color: var(--gs-foreground);
  font-size: 14px;
  font-weight: 600;
  text-overflow: ellipsis;
  text-transform: capitalize;
  white-space: nowrap;
}

.gv-video-settings-panel .gv-storage__actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.gv-video-settings-panel .gv-storage__actions--stacked {
  flex-direction: column;
}

.gv-video-settings-panel .gv-storage__actions .gs-button {
  min-width: 240px;
}

.gv-video-settings-panel .gv-storage__help {
  margin: 20px 0 0;
  color: var(--gs-muted-foreground);
  font-size: 13px;
  text-align: center;
}

.gv-video-settings-panel .gv-storage__help-link {
  color: var(--gs-primary);
}

.gv-video-settings-modal-actions {
  margin-top: 8px;
}

@media (max-width: 640px) {
  .gv-video-settings-panel .gv-storage__grid {
    grid-template-columns: 1fr;
  }

  .gv-video-settings-panel .gv-storage__actions {
    align-items: stretch;
    flex-direction: column;
    width: 100%;
  }

  .gv-video-settings-panel .gv-storage__actions .gs-button {
    min-width: 0;
    width: 100%;
  }
}
</style>
